import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function ServiceStatus() {
  const services = [
    { name: 'Web Application', status: 'Hoạt động', icon: 'ri-global-line' },
    { name: 'Database', status: 'Hoạt động', icon: 'ri-database-2-line' },
    { name: 'File Storage', status: 'Hoạt động', icon: 'ri-folder-shield-2-line' },
    { name: 'Email Service', status: 'Hoạt động', icon: 'ri-mail-send-line' },
    { name: 'Backup Service', status: 'Hoạt động', icon: 'ri-cloud-line' },
  ];

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-sm font-bold text-slate-800">Trạng thái dịch vụ</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem chi tiết</button>
        </div>

        <div className="flex-1 space-y-5">
          {services.map((svc) => (
            <div key={svc.name} className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <i className={`${svc.icon} text-slate-400 text-lg`} />
                <span className="text-xs font-bold text-slate-600">{svc.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-bold text-emerald-600">{svc.status}</span>
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-blue-500 flex items-center gap-1 hover:underline">
            Xem tất cả dịch vụ <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
